// query-keys/job-keys.js
import { queryClient } from "utils/react-query";

const collection = "billables";

export const billableKeys = {
  // Base keys
  all: [collection],
  meta: (id) => [...billableKeys.all, "meta", id],
  count: (id) => [...billableKeys.all, "count", id],
  details: () => [...billableKeys.all, "detail"],
  detail: (id) => [...billableKeys.details(), id],
  allocatedSum: (id) => [...billableKeys.all, "allocated", id],
  allApprovedHours: (id) => [...billableKeys.all, "approved", id],
  allLoggedHours: (id) => [...billableKeys.all, "logged", id],
};

export function invalidateJobQueries() {
  const predicates = [
    // Invalidate all job lists
    ({ queryKey }) => queryKey[0] === collection && queryKey[1] === "list",
  ];

  predicates.forEach((predicate) => {
    queryClient.invalidateQueries({ predicate });
  });
}

// Additional helper for invalidating all job queries
export function invalidateAllJobQueries() {
  queryClient.invalidateQueries({
    predicate: ({ queryKey }) => queryKey[0] === collection,
  });
}
